import { CommunityReplyFragment } from 'generated/graphql';
import auth from '@client/components/auth';
import { randomId } from '@client/new/helpers/id';

export const OPTIMISTIC_REPLY_PREFIX = 'optimistic-';

type Identity = { name: string; avatarUrl: string | null } | null;

export const createOptimisticReply = (
  text: string,
  identity: Identity,
): CommunityReplyFragment => {
  const user = auth.getUser();
  const fullName = [user?.firstName, user?.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();

  return {
    __typename: 'Reply',
    id: `${OPTIMISTIC_REPLY_PREFIX}${randomId()}`,
    text,
    createdAt: new Date().toISOString(),
    isSensitiveContent: false,
    reactions: [],
    author: {
      __typename: 'Author',
      id: user?.id ?? 0,
      username: identity?.name || fullName,
      profilePicture: identity?.avatarUrl ?? '',
      badges: ['own'],
      email: user?.email ?? '',
      hasDirectMessagesAccess: null,
    },
  };
};
